<template>
    <div v-if="!skip_3_step">
        <v-row align="center" justify="center">
            <v-col cols="12" lg="8" md="8" sm="8">
                <v-card class="mx-auto">
                    <v-app-bar color="grey lighten-3" elevation="0" height="82">
                        <v-row align="center" justify="center">
                            <span class="title">
                                {{ $t("check_requisites.data_analize") }}
                            </span>
                        </v-row>
                    </v-app-bar>

                    <v-progress-linear
                        :value="checkPercent"
                        height="40"
                        striped
                        color="deep-orange accent-2"
                    >
                        <span class="subtitle-2 font-weight-bold">{{ progressText }}</span>
                    </v-progress-linear>

                    <div style="margin: 30px;">
                        <v-row>
                            <v-col>
                                <v-row>
                                    <!--<span class="subtitle-1 font-weight-bold">-->
                                    <!--{{name}} {{second_name}}, идет проверка Ваших данных...-->
                                    <!--</span>-->
                                    <span class="subtitle-2">
                                        {{ $t("check_requisites.checking_information") }}
                                    </span>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" xs="12" sm="6">
                                        <v-row>
                                            <v-col align="center" justify="center">
                                                <span style="font-size: 2rem; font-weight: bold;"
                                                    >{{ checkPercent }}%&nbsp;</span
                                                >
                                                <span class="font-weight-bold">{{
                                                    $t("done")
                                                }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6">
                                        <v-row>
                                            <v-col align="center" justify="center">
                                                <span style="font-size: 2rem; font-weight: bold;"
                                                    >{{ data_count }}&nbsp;</span
                                                >
                                                <span class="font-weight-bold">
                                                    {{
                                                        $t(
                                                            "check_requisites.data_check_without_count"
                                                        )
                                                    }}
                                                </span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-carousel
                                        height="300"
                                        v-model="model"
                                        :show-arrows="false"
                                        :hide-delimiters="true"
                                        :cycle="false"
                                    >
                                        <v-carousel-item transition="slide-y-transition">
                                            <v-sheet color="white" height="100%" tile>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 30px;
                                                            font-weight: 600;
                                                        "
                                                    >
                                                        {{ $t("check_requisites.step_1") }}
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-left: 20px;
                                                        "
                                                    >
                                                        {{ $t("check_requisites.check_fio") }}
                                                    </v-col>
                                                    <v-col
                                                        align="right"
                                                        justify="right"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-right: 20px;
                                                        "
                                                    >
                                                        <v-icon
                                                            v-if="checkPercent > 8"
                                                            :size="icons_size"
                                                            :color="color"
                                                            >mdi-check-outline</v-icon
                                                        >
                                                        <!--                                                        <looping-rhombuses-spinner-->
                                                        <!--                                                                v-else-->
                                                        <!--                                                                :animation-duration="an_duration"-->
                                                        <!--                                                                :rhombus-size="icons_size"-->
                                                        <!--                                                                :color="color"-->
                                                        <!--                                                        />-->
                                                        <v-progress-circular
                                                            :size="icons_size"
                                                            v-else
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-left: 20px;
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                "check_requisites.check_date_of_birth"
                                                            )
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        align="right"
                                                        justify="right"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-right: 20px;
                                                        "
                                                    >
                                                        <v-icon
                                                            v-if="checkPercent > 15"
                                                            :size="icons_size"
                                                            :color="color"
                                                            >mdi-check-outline</v-icon
                                                        >
                                                        <!--                                                        <looping-rhombuses-spinner-->
                                                        <!--                                                                v-else-->
                                                        <!--                                                                :animation-duration="an_duration"-->
                                                        <!--                                                                :rhombus-size="icons_size"-->
                                                        <!--                                                                :color="color"-->
                                                        <!--                                                        />-->
                                                        <v-progress-circular
                                                            :size="icons_size"
                                                            v-else
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                    </v-col>
                                                </v-row>
                                            </v-sheet>
                                        </v-carousel-item>

                                        <v-carousel-item transition="slide-y-transition">
                                            <v-sheet color="white" height="100%" tile>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 30px;
                                                            font-weight: 600;
                                                        "
                                                    >
                                                        {{ $t("check_requisites.step_2") }}
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-left: 20px;
                                                        "
                                                    >
                                                        {{ $t("check_requisites.check_email") }}
                                                    </v-col>
                                                    <v-col
                                                        align="right"
                                                        justify="right"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-right: 20px;
                                                        "
                                                    >
                                                        <v-icon
                                                            v-if="checkPercent > 28"
                                                            :size="icons_size"
                                                            :color="color"
                                                            >mdi-check-outline</v-icon
                                                        >
                                                        <!--                                                        <looping-rhombuses-spinner-->
                                                        <!--                                                                v-else-->
                                                        <!--                                                                :animation-duration="an_duration"-->
                                                        <!--                                                                :rhombus-size="icons_size"-->
                                                        <!--                                                                :color="color"-->
                                                        <!--                                                        />-->
                                                        <v-progress-circular
                                                            :size="icons_size"
                                                            v-else
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-left: 20px;
                                                        "
                                                    >
                                                        {{ $t("check_requisites.check_phone") }}
                                                    </v-col>
                                                    <v-col
                                                        align="right"
                                                        justify="right"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-right: 20px;
                                                        "
                                                    >
                                                        <v-icon
                                                            v-if="checkPercent > 35"
                                                            :size="icons_size"
                                                            :color="color"
                                                            >mdi-check-outline</v-icon
                                                        >
                                                        <!--                                                        <looping-rhombuses-spinner-->
                                                        <!--                                                                v-else-->
                                                        <!--                                                                :animation-duration="an_duration"-->
                                                        <!--                                                                :rhombus-size="icons_size"-->
                                                        <!--                                                                :color="color"-->
                                                        <!--                                                        />-->
                                                        <v-progress-circular
                                                            :size="icons_size"
                                                            v-else
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                    </v-col>
                                                </v-row>
                                                <!--<v-row>-->
                                                <!--<v-col align="left"-->
                                                <!--justify="left"-->
                                                <!--style="color:black; margin: 20px">-->
                                                <!--Проверяю паспорт-->
                                                <!--</v-col>-->
                                                <!--<v-col align="right"-->
                                                <!--justify="right"-->
                                                <!--style="color:black; margin: 20px">-->
                                                <!--<v-icon x-large :color="color">mdi-check-outline</v-icon>-->
                                                <!--<looping-rhombuses-spinner-->
                                                <!--:animation-duration="2000"-->
                                                <!--:rhombus-size="18"-->
                                                <!--:color="color"-->
                                                <!--/>-->
                                                <!--</v-col>-->
                                                <!--</v-row>-->
                                                <!--<v-row>-->
                                                <!--<v-col align="left"-->
                                                <!--justify="left"-->
                                                <!--style="color:black; margin: 20px">-->
                                                <!--Проверяю задолженности ФССП-->
                                                <!--</v-col>-->
                                                <!--<v-col align="right"-->
                                                <!--justify="right"-->
                                                <!--style="color:black; margin: 20px">-->
                                                <!--<v-icon x-large :color="color">mdi-check-outline</v-icon>-->
                                                <!--<looping-rhombuses-spinner-->
                                                <!--:animation-duration="2000"-->
                                                <!--:rhombus-size="18"-->
                                                <!--:color="color"-->
                                                <!--/>-->
                                                <!--</v-col>-->
                                                <!--</v-row>-->
                                            </v-sheet>
                                        </v-carousel-item>

                                        <v-carousel-item transition="slide-y-transition">
                                            <v-sheet color="white" height="100%" tile>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 30px;
                                                            font-weight: 600;
                                                        "
                                                    >
                                                        {{ $t("check_requisites.step_3") }}
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-left: 20px;
                                                        "
                                                    >
                                                        {{ $t("check_requisites.check_social") }}
                                                    </v-col>
                                                    <v-col
                                                        align="right"
                                                        justify="right"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-right: 20px;
                                                        "
                                                    >
                                                        <v-icon
                                                            v-if="checkPercent > 48"
                                                            :size="icons_size"
                                                            :color="color"
                                                            >mdi-check-outline</v-icon
                                                        >
                                                        <!--                                                        <looping-rhombuses-spinner-->
                                                        <!--                                                                v-else-->
                                                        <!--                                                                :animation-duration="an_duration"-->
                                                        <!--                                                                :rhombus-size="icons_size"-->
                                                        <!--                                                                :color="color"-->
                                                        <!--                                                        />-->
                                                        <v-progress-circular
                                                            :size="icons_size"
                                                            v-else
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-left: 20px;
                                                        "
                                                    >
                                                        {{
                                                            $t("check_requisites.check_messengers")
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        align="right"
                                                        justify="right"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-right: 20px;
                                                        "
                                                    >
                                                        <v-icon
                                                            v-if="checkPercent > 55"
                                                            :size="icons_size"
                                                            :color="color"
                                                            >mdi-check-outline</v-icon
                                                        >
                                                        <!--                                                        <looping-rhombuses-spinner-->
                                                        <!--                                                                v-else-->
                                                        <!--                                                                :animation-duration="an_duration"-->
                                                        <!--                                                                :rhombus-size="icons_size"-->
                                                        <!--                                                                :color="color"-->
                                                        <!--                                                        />-->
                                                        <v-progress-circular
                                                            :size="icons_size"
                                                            v-else
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                    </v-col>
                                                </v-row>
                                            </v-sheet>
                                        </v-carousel-item>

                                        <v-carousel-item transition="slide-y-transition">
                                            <v-sheet color="white" height="100%" tile>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 30px;
                                                            font-weight: 600;
                                                        "
                                                    >
                                                        {{ $t("check_requisites.step_4") }}
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col
                                                        align="left"
                                                        justify="left"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-left: 20px;
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                "check_requisites.find_personal_offers"
                                                            )
                                                        }}
                                                    </v-col>
                                                    <v-col
                                                        align="right"
                                                        justify="right"
                                                        style="
                                                            color: black;
                                                            margin: 10px;
                                                            margin-right: 20px;
                                                        "
                                                    >
                                                        <v-icon
                                                            v-if="checkPercent > 95"
                                                            :size="icons_size"
                                                            :color="color"
                                                            >mdi-check-outline</v-icon
                                                        >
                                                        <!--                                                        <looping-rhombuses-spinner-->
                                                        <!--                                                                v-else-->
                                                        <!--                                                                :animation-duration="an_duration"-->
                                                        <!--                                                                :rhombus-size="icons_size"-->
                                                        <!--                                                                :color="color"-->
                                                        <!--                                                        />-->
                                                        <v-progress-circular
                                                            :size="icons_size"
                                                            v-else
                                                            indeterminate
                                                            color="primary"
                                                        ></v-progress-circular>
                                                    </v-col>
                                                </v-row>
                                            </v-sheet>
                                        </v-carousel-item>

                                        <v-carousel-item transition="slide-y-transition">
                                            <v-sheet color="white" height="100%" tile>
                                                <v-row>
                                                    <v-col
                                                        align="center"
                                                        justify="center"
                                                        style="color: black; margin: 20px;"
                                                    >
                                                        {{ user.name }} {{ user.second_name }},
                                                        {{ $t("check_requisites.check_ended") }}
                                                    </v-col>
                                                </v-row>
                                                <!--                                                <v-row>-->
                                                <!--                                                    <v-col align="center"-->
                                                <!--                                                           justify="center"-->
                                                <!--                                                           style="color:black; margin: 20px">-->
                                                <!--                                                        <v-btn @click="completeRegistration" color="secondary" style="height: 60px" class="subtitle-1">-->
                                                <!--                                                            {{$t('continue')}}-->
                                                <!--                                                            <v-icon large color="white">mdi-arrow-right</v-icon>-->
                                                <!--                                                        </v-btn>-->
                                                <!--                                                    </v-col>-->
                                                <!--                                                </v-row>-->
                                            </v-sheet>
                                        </v-carousel-item>
                                    </v-carousel>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div style="margin: 30px;">
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import BIcon from "buefy/src/components/icon/Icon";

import settings from "@/environment";

export default {
    name: "CheckRequisites",
    components: {
        BIcon,
    },
    data() {
        return {
            checkPercent: 0,
            data_count: 0,
            progressText: this.$t("check_requisites.data_ckecking"),
            min: 1,
            max: 4,
            model: 0,
            color: this.$vuetify.theme.themes.light.primary,
            an_duration: 1000,
            icons_size: 25,
            skip_3_step: settings.skip_3_step,
        };
    },
    created() {
        this.skip_step();
        this.addPercent();
    },
    methods: {
        next() {
            if (
                this.app_settings.payments.enabled &&
                this.app_settings.payments.registration &&
                this.app_settings.payments.after_check_requisites
            ) {
                this.paymentsCredentials();
            } else {
                this.completeRegistration();
            }
        },
        paymentsCredentials() {
            this.$router.push({
                path: `/payment-credentials?api_key=${this.$store.getters.GET_REGISTRATED_USER_APIKEY}`,
            });
        },
        completeRegistration() {
            this.$store
                .dispatch("COMPLETE_REGISTRATION")
                .then((user) => {
                    this.$store
                        .dispatch("AUTH_BY_API_KEY", user.api_key)
                        .then(() => {
                            this.$router.push({ path: "/panel/offers" });
                        })
                        .catch(() => {
                            this.$toast.error(this.$t("errors.unknown_error"));
                        });
                })
                .catch(() => {
                    this.$toast.error(this.$t("errors.unknown_error"));
                });
        },
        addPercent() {
            const _this = this;
            const x = setInterval(() => {
                const rand = Math.round(Math.random() * (_this.max - _this.min)) + _this.min;
                _this.checkPercent += rand;
                _this.data_count += Math.round(Math.random() * 10);
                if (_this.checkPercent < 20) {
                    _this.model = 0;
                } else if (_this.checkPercent >= 20 && _this.checkPercent < 40) {
                    _this.model = 1;
                } else if (_this.checkPercent >= 40 && _this.checkPercent < 60) {
                    _this.model = 2;
                } else if (_this.checkPercent >= 60 && _this.checkPercent < 100) {
                    _this.model = 3;
                } else if (_this.checkPercent > 100) {
                    _this.checkPercent = 100;
                    clearInterval(x);
                    _this.model = 4;
                    _this.progressText = this.$t("check_requisites.check_done");
                    setTimeout(() => {
                        _this.next();
                    }, 1500);
                }
            }, 300);
        },
        skip_step() {
            if (this.skip_3_step) {
                this.next();
            }
        },
    },
    computed: {
        app_settings() {
            return this.$store.getters.APP_SETTINGS;
        },
        user() {
            return this.$store.getters.GET_REGISTRATED_USER;
        },
    },
};
</script>

<style>
.layout-navbar {
    height: 100px !important;
}
</style>
